/* eslint-disable no-useless-concat */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import 'react-tabs/style/react-tabs.css'
import axios from 'axios'
import {
  getPriceJbp,
  getPriceAll,
  getDetailJbp,
  getPriceJbpSearch,
  getSalesOrgAllMasterData,
  getRegionAllMasterData,
  getFilterCityMasterData,
  getByProduct,
  getPriceAllSearch,
  getIncotermAll,
  getAllIncoterms,
  getJbpTypeMasterData,
  getDetailJbpPricing,
} from '../../../../../api/modules/master-data/master_2'
import {getAllPlants, getCustomerAll, getCustomerSearch, getPlant, getPlantSearch} from '../../../../../api/modules/master-data/master'
import Pagination from '../../../component/Pagination'
import swal from 'sweetalert'
import {getAccessesPriceJbp} from '../../../../../api/modules/access/access'
import CreatableSelect from 'react-select/creatable'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Link, useNavigate, useParams} from 'react-router-dom'
import Select from 'react-select'
import {MultiSelect} from 'react-multi-select-component'
import InputGroup from 'react-bootstrap/InputGroup'
import i18next from 'i18next'
import CurrencyInput from 'react-currency-input-field'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import {Spinner} from 'react-bootstrap'
import CustomUseEffect from './CustomUseEffect'
import {id} from 'date-fns/locale'
import {match} from 'assert'
import {ModalBrowsBasicPrices, ModalBrowseCustomers} from '../../../../../components'
import Skeleton from 'react-loading-skeleton'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { getPlantV2 } from 'src/api/modules/getdatalist'
import dateformat from 'src/utils/dateformat'

type Props = {
  className: string
}

const Create: React.FC<Props> = ({className}) => {
  const intl = useIntl()
  const navigate = useNavigate()

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)

  const params = useParams()

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  const [price, setPrice] = useState<any[]>([])
  const [product, setProduct] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [customer, setCustomer] = useState<any>()
  const [sorg, setSorg] = useState<any>()
  const [regions, setRegions] = useState<any[]>([])
  const [regionCreate, setRegionCreate] = useState<any>('')
  const [cities, setCities] = useState<any>([])
  const [numberURLProduct, setNumberURLProduct] = useState([])

  const [plants, setPlants] = useState([])
  const [incoterms, setIncoterms] = useState([])

  const getPlants = async (sales_org: string, material_number: string) => {
    setLoadingPlant(true)
    const res = await getPlantV2(sales_org, material_number)
    const data = res.data.data
    setPlants(data.map((_item: any) => {
      return {
        value: _item.plant,
        label: [
          _item.plant,
          _item.plant_name,
        ].join(" - ")
      }
    }))
    setLoadingPlant(false)
}

  useEffect(() => {
    const getSalesOrg = async () => {
      setLoadingSalesOrg(true)
      const res = await getSalesOrgAllMasterData()
      const data = res.data.data

      try{
        const cred = atob(localStorage.getItem('credential') || "")
        const credential = JSON.parse(cred)
        setSorg(data.filter((item: any) => {
          return credential.sales_organization?.split("|").includes(item.code)
        }))
      }catch(e){
        setSorg([])
      }
      
      setLoadingSalesOrg(false)
    }
    const getIncoterms = async () => {
        setLoadingIncoterm(true)
        const res = await getAllIncoterms()
        const data = res.data.data

        setIncoterms(data.map((_item: any) => {
            return {
                code: _item.code,
                name: _item.code,
            }
        }))
        setLoadingIncoterm(false)
    }

    const getRegion = async () => {
      setLoadingRegion(true)
      const res = await getRegionAllMasterData()
      const data = res.data.data
      setRegions(data)
      setLoadingRegion(false)
    }

    getRegion()
    getSalesOrg()
    getIncoterms()
    // getCustomer()
    // getPriceDasar()
  }, [])

  useEffect(() => {
    handleEdit()
  }, [params.id])

  const [group, setGroup] = useState('')
  const [name, setName] = useState('')
  const [code, setCode] = useState('')

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getCustomerSearch(code, name, group).then((res: any) => {
        setCustomer(res.data.data)
        setNumberURL(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [code, name, group])

  const paginateNumber = async (number: any) => {
    setLoading(true)
    const res = await axios.get(number, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
    const data = res.data.data
    setCustomer(data.data)
    setPage(data.current_page)
    setPer(data.per_page)
    setLoading(false)
    setNumberURL(data.links)
  }

  const [salesOrgCode, setSalesOrgCode] = useState('')
  const [customerCode, setCustomerCode] = useState('')
  const [productCode, setProductCode] = useState('')
  const [regionCode, setRegionCode] = useState<any>('')
  const [cityCode, setCityCode] = useState<any>('')
  const [citiCreate, setCitiCreate] = useState<any[]>([])
  const [minimumPrice, setMinimumPrice] = useState<any>(0)
  const [sellingPrice, setSellingPrice] = useState<any>()
  const [discount, setDiscount] = useState('')
  const [purchasePrice, setPurchasePrice] = useState<any>(0)
  const [validFrom, setValidFrom] = useState<any>()
  const [validTo, setValidTo] = useState<any>()
  const [type, setType] = useState('jbp')
  const [isActive, setIsActive] = useState('')
  const [desc, setDesc] = useState('')
  const [isUpload, setIsUpload] = useState(false)

  const [jbpTypes, setJbpTypes] = useState([])
  const [jbpType, setJbpType] = useState("")

  const handleSalesOrg = async (e: any) => {
    setSalesOrgCode(e)
    getJbpTypes(e)
    getPlants(e, productCode)

    setPlant('')
  }
  const handleJbpType = (e: any) => {
    setType(e)
    if(e == 'non-jbp'){
      setJbpType('')
    }
  } 
  const getJbpTypes = async (val: string) => {
    setLoadingJbpType(true)
    await getJbpTypeMasterData(val).then((res: any) => {
      const data = res.data.data
      setJbpTypes(data.map((_item: any) => {
        return {
          id: _item.id,
          label: [
            _item.code,
            _item.type
          ].join(" - ")
        }
      }))
    })
    setLoadingJbpType(false)
  }
  const handleRegion = async (e: any) => {
    setRegionCode(e)

    await getFilterCityMasterData([e]).then((res: any) => {
      const data = res.data.data
      setCities(data)
    })
  }

  const handleProduct = async (e: any) => {
    setProductCode(e)

    if (e !== null) {
      handleClose2()
      setPlant('')
      getPlants(salesOrgCode, e)
    }

    await getByProduct(e).then((res: any) => {
      const data = res.data.data
      setMinimumPrice(data?.price)
    })
  }

  const postPrice = async () => {
    if(!editId){
      setBtnLoading(true)
      axios
        .post(
          `${
            process.env.REACT_APP_PI_BACKEND_API_MASTERDATA_V2
          }/price-list/pricing/create?credentials=${localStorage.getItem('credential')}`,
          {
            company_code: salesOrgCode,
            product_code: productCode,
            basic_price: minimumPrice,
            price: sellingPrice,
            valid_from: validFrom ? moment(validFrom).format('yyyy-MM-DD') : null,
            valid_to: validTo ? moment(validTo).format('yyyy-MM-DD') : null,
            plant: plant,
            is_jbp: type == 'jbp',
            jbp_type_id: jbpType,
            incoterm,
            is_active: isActive == 'true',
            lang: language
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
              Accept: 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then((response) => {
          if (!response.data.error) {
            setIsUpload(true)
  
            handleClose()
            swal({
              title: `${t('Harga JBP Berhasil di Tambahkan')}`,
              icon: 'success',
            }).then(() => {
              navigate(`/master/pricing`)
            })
          }
        })
        .catch((error) => {
          if (error.response.data.message.match('tidak ada price list dasar')) {
            swal({
              title: `${t('kode product tidak ditemukan')}`,
              icon: 'error',
            })
          } else {
            swal({
              title: `${t(error.response.data.message)}`,
              icon: 'error',
            })
          }
        })
        .finally(() => {
          setBtnLoading(false)
        })
    }else{
      setBtnLoading(true)
      axios
        .put(
          `${
            process.env.REACT_APP_PI_BACKEND_API_MASTERDATA_V2
          }/price-list/pricing/${params.type}/edit/${editId}?credentials=${localStorage.getItem('credential')}`,
          {
            pricing_type: params.type,
            company_code: salesOrgCode,
            product_code: productCode,
            basic_price: minimumPrice,
            price: sellingPrice,
            valid_from: validFrom ? moment(validFrom).format('yyyy-MM-DD') : null,
            valid_to: validTo ? moment(validTo).format('yyyy-MM-DD') : null,
            plant: plant,
            is_jbp: type == 'jbp',
            jbp_type_id: jbpType,
            incoterm,
            is_active: isActive == 'true',
            lang: language
          },
          {
            headers: {
              pricing_type: params.type,
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
              Accept: 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          }
        )
        .then((response) => {
          if (!response.data.error) {
            setIsUpload(true)
  
            handleClose()
            swal({
              title: `${t('Harga JBP Berhasil di Edit')}`,
              icon: 'success',
            }).then(() => {
              navigate(`/master/pricing`)
            })
          }
        })
        .catch((error) => {
          if (error.response.data.message.match('tidak ada price list dasar')) {
            swal({
              title: `${t('kode product tidak ditemukan')}`,
              icon: 'error',
            })
          } else {
            swal({
              title: `${t(error.response.data.message)}`,
              icon: 'error',
            })
          }
        })
        .finally(() => {
          setBtnLoading(false)
        })
    }
  }

  const [editId, setEditId] = useState<any>('')

  const handleEdit = async () => {
    if(params.id){
      handleShow1()
      setEditId(params.id)
      
      setLoading(true)
      const res = await getDetailJbpPricing(params.type, params.id)
      const data = res.data.data

      handleSalesOrg(data.company_code)
      setType(data.is_jbp || data.jbp_type_id ? 'jbp' : 'non-jbp')
      setJbpType(data.jbp_type_id)
      setProductCode(data.product_code)
      setMinimumPrice(data.basic_price)
      setSellingPrice(data.price)
      setPlant(data.plant)
      setIncoterm(data.incoterm)
      setValidFrom(moment(data.valid_from).format('YYYY-MM-DD'))
      setValidTo(moment(data.valid_to).format('YYYY-MM-DD'))
      setIsActive(data.is_active ? 'true': 'false')
      getPlants(data?.company_code, data?.product_code)
      setLoading(false)
    }
  
  }

  //#region state for search
  const [salesorg, setSalesorg] = useState('')
  const [custcode, setCustcode] = useState('')
  const [productcode, setProducecode] = useState('')
  const [region, setRegion] = useState('')
  const [city, setCity] = useState('')
  const [minprice, setMinprice] = useState('')
  const [sellprice, setSellprice] = useState('')
  const [dist, setDist] = useState('')
  const [purchaseprice, setPurchaseprice] = useState('')
  //#endregion

  const [disabled, setDisabled] = useState(false)

  const handlePrice = async (e: any) => {
    setDiscount(e)
    const temp = sellingPrice - sellingPrice * (e / 100)
    if (e == '') {
      setPurchasePrice(0)
    } else {
      setPurchasePrice(Number.isNaN(temp) ? 0 : temp)
    }
  }

  const handlePrice2 = async (e: any) => {
    setSellingPrice(e)
    const temp = e - e * (Number(discount) / 100)
    if (discount == '') {
      setPurchasePrice(0)
    } else {
      setPurchasePrice(Number.isNaN(temp) ? 0 : temp)
    }
  }

  // if customerCode != null, then disabled all checkbox
  const handleCustomer = async (e: any) => {
    setCustomerCode(e)
    if (e !== null) {
      handleClose()
    }
  }

  const options = product.map((item: any) => {
    return {value: item.product_code, label: item.product_code.slice(-7)}
  })

  const [language, setLanguage] = useState<any>()
  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const paginateNumberProduct = async (number: any) => {
    setLoading(true)
    const res = await axios.get(number, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
    const data = res.data.data
    setProduct(data.data)
    setPage(data.current_page)
    setPer(data.per_page)
    setLoading(false)
    setNumberURLProduct(data.links)
  }

  const [codeSearch, setCodeSearch] = useState('')
  const [nameSearch, setNameSearch] = useState('')
  const [searchprice, setSearchPrice] = useState<any>('')

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getPriceAllSearch(codeSearch, nameSearch, searchprice).then((res: any) => {
        setProduct(res.data.data.data)
        setNumberURLProduct(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [codeSearch, nameSearch, searchprice])

  CustomUseEffect(() => {
    const product_Code = document.getElementById('product_Code') as HTMLInputElement
    if (product_Code != null) product_Code.value = ''
    const status = document.getElementById('status') as HTMLSelectElement
    if (status != null) status.selectedIndex = 0
    const customer_Code = document.getElementById('customer_Code') as HTMLInputElement
    if (customer_Code != null) customer_Code.value = ''
    const minimum_price = document.getElementById('minimum_price') as HTMLInputElement
    if (minimum_price != null) minimum_price.value = '0'
    const disc = document.getElementById('disc') as HTMLInputElement
    if (disc != null) disc.value = ''
    const purchase_price = document.getElementById('purchase_price') as HTMLInputElement
    if (purchase_price != null) purchase_price.value = '0'
    const dateFrom = document.getElementById('date') as HTMLInputElement
    if (dateFrom != null) dateFrom.value = ''
    const dateTo = document.getElementById('datee') as HTMLInputElement
    if (dateTo != null) dateTo.value = ''
    const desc = document.getElementById('desc') as HTMLInputElement
    if (desc != null) desc.value = ''
    // setRegionCode([])
  }, [salesOrgCode])

  const [plant, setPlant] = useState('')
  const [incoterm, setIncoterm] = useState('')

  const [loadingSalesOrg, setLoadingSalesOrg] = useState(false)
  const [loadingRegion, setLoadingRegion] = useState(false)
  const [loadingJbpType, setLoadingJbpType] = useState(false)
  const [loadingPlant, setLoadingPlant] = useState(false)
  const [loadingIncoterm, setLoadingIncoterm] = useState(false)

  // const showJbpType = (editId && type == 'jbp' && jbpType) || (!editId && type == 'jbp')
  const showJbpType = type == 'jbp'
  const disableJbpType = editId && jbpType
  const disableJbpTypeId = !salesOrgCode || type != 'jbp'

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {editId ? t('page edit harga JBP') : t('page harga JBP')}
      </PageTitle>

      <div className={`card ${className}`}>
        <div className='card-body mt-5'>
        {
            loading ? <div className='d-flex justify-content-center'>
            <div className='spinner-border text-primary' role='status'>
              <span className='sr-only'>Loading...</span>
            </div>
          </div>
           : <div>
            <Row className='mb-4'>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>{t('sub-order-produsen')}</Form.Label>
                  { loadingSalesOrg ? <Skeleton className='w-100' width={'100%'} height={43} />
                  : <Form.Select
                    size='sm'
                    aria-label='Default select example'
                    value={salesOrgCode}
                    onChange={(e: any) => {
                      handleSalesOrg(e.target.value)
                    }}
                  >
                    <option value="">
                      {t('Choose')} {t('sub-order-produsen')}
                    </option>
                    {sorg?.map((item: any, index: number) => (
                      <option key={item?.code ?? index} value={item?.code}>
                        {item?.name}
                      </option>
                    ))}
                  </Form.Select>
                }
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>{t('price-type')}</Form.Label>
                  <Form.Select
                    size='sm'
                    aria-label='Default select example'
                    onChange={(e: any) => handleJbpType(e.target.value)}
                    value={type}
                    // disabled={disableJbpType}
                    id='status'
                  >
                    <option value=''>{t('Choose') + ' ' + t('type')}</option>
                    <option value='jbp'>Prioritas</option>
                    <option value='non-jbp'>Basic</option>
                  </Form.Select>
                </Form.Group>
              </Col>

            </Row>

            <Row className='mb-3'>
              { showJbpType && <Col md={6} className='mb-3'>
                <Form.Group>
                  <Form.Label>{ t('jbp-type') }</Form.Label>
                  { loadingJbpType ? <Skeleton className='w-100' width={'100%'} height={43} />
                  : <Form.Select
                    size='sm'
                    value={jbpType}
                    aria-label='Default select example'
                    disabled={disableJbpTypeId}
                    onChange={(e: any) => setJbpType(e.target.value)}
                    id='jbp-type'
                  >
                    <option value="">{t('Choose') + ' ' + t('jbp-type')}</option>
                    {jbpTypes?.map((item: any, index: number) => (
                      <option key={item?.id ?? index} value={item?.id}>
                        {item?.label}
                      </option>
                    ))}
                  </Form.Select>
                }
                </Form.Group>
              </Col>
            }

            <Col md={6} className='mb-3'>
                <Form.Group>
                  <Form.Label>{t('Product Code')}</Form.Label>
                  <div className='d-flex'>
                    <Form.Control
                      key={salesOrgCode}
                      id='product_Code'
                      size='sm'
                      className='me-1'
                      type='text'
                      placeholder={t('Product Code')}
                      value={productCode.slice(-7)}
                      disabled
                    />
                    <Button size='sm' className='btn btn-primary' onClick={handleShow2}>
                      {t('Browse')}
                    </Button>
                  </div>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Minimum {t('Harga')}</Form.Label>
                  <InputGroup className='mb-3' size='sm'>
                    <InputGroup.Text>
                      <span className='px-1'>Rp</span>
                    </InputGroup.Text>
                    <CurrencyInput
                      key={salesOrgCode}
                      className='form-control form-control-sm'
                      placeholder={t('Harga')}
                      decimalSeparator={language === 'en' ? '.' : ','}
                      value={minimumPrice}
                      disabled={true}
                      groupSeparator={language === 'en' ? ',' : '.'}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>{t('Selling Price')}</Form.Label>
                  <InputGroup className='mb-3' size='sm'>
                    <InputGroup.Text>
                      <span className='px-1'>Rp</span>
                    </InputGroup.Text>
                    <CurrencyInput
                      key={salesOrgCode}
                      className='form-control form-control-sm'
                      placeholder={t('Selling Price')}
                      decimalSeparator={language === 'en' ? '.' : ','}
                      value={sellingPrice}
                      groupSeparator={language === 'en' ? ',' : '.'}
                      onValueChange={(value: any) => {
                        handlePrice2(value)
                      }}
                      decimalsLimit={-1}
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <Row className='mb-4'>
            <Col md={6}>
                <Form.Group>
                  <Form.Label>{ t('sub-order-gudang') }</Form.Label>
                  { loadingPlant ? <Skeleton className='w-100' width={'100%'} height={43} />
                  : <Select
                      key={salesOrgCode + productCode}
                      placeholder={t('pilih') + ' ' + t('sub-order-gudang')} 
                      onChange={(e: any) => setPlant(e?.value)} 
                      options={plants} 
                      defaultValue={plants[plants.findIndex((x: any) => x.value == plant)]}
                />
                }
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>{ t('sub-order-incoterm') }</Form.Label>
                  { loadingIncoterm ? <Skeleton className='w-100' width={'100%'} height={43} />
                   : <Form.Select
                    aria-label='Default select example'
                    value={incoterm}
                    onChange={(e: any) => setIncoterm(e.target.value)}
                    id='incoterm'
                    size='sm'
                  >
                    <option value=''>{t('Choose') + ' ' + t('sub-order-incoterm')}</option>
                    {incoterms?.map((item: any, index: number) => (
                      <option key={item?.code +'-'+ index} value={item?.code}>
                        {item?.name}
                      </option>
                    ))}
                  </Form.Select>
                }
                </Form.Group>
              </Col>
            </Row>

            <Row className='mb-3'>
              <Col md={6} className='mb-3'>
                <Form.Group>
                  <Form.Label>{t('Valid From')}</Form.Label>
                  <Form.Control
                    type='date'
                    value={validFrom}
                    style={{height: '40px'}}
                    disabled={false}
                    size='sm' 
                    onChange={(e: any) => setValidFrom(e?.target?.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>{t('Valid To')}</Form.Label>
                  <Form.Control
                    type='date'
                    value={validTo}
                    style={{height: '40px'}}
                    disabled={false}
                    size='sm' 
                    onChange={(e: any) => setValidTo(e?.target?.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                  value={isActive}
                    aria-label='Default select example'
                    onChange={(e: any) => setIsActive(e.target.value)}
                    id='status'
                    size='sm'
                  >
                    <option value=''>{t('Choose') + ' ' + 'Status'}</option>
                    <option value='true'>{t('Active')}</option>
                    <option value='false'>{t('Non-Active')}</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <div className='d-flex justify-content-end'>
              <Link to={'/master/pricing'}>
                <Button variant='secondary' className='me-2'>
                  {t('Back')}
                </Button>
              </Link>

              <Button variant='primary' onClick={postPrice} disabled={btnLoading}>
                {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : ( editId ? t('ubah') :  t('buat') )}
              </Button>
            </div>
          </div>
        }
        </div>
      </div>

      <ModalBrowseCustomers
        show={show}
        selected={customerCode}
        onClose={handleClose}
        onSelectCustomer={(customerId) => handleCustomer(customerId)}
      />

      <ModalBrowsBasicPrices
        show={show2}
        selected={productCode}
        onClose={handleClose2}
        onSelected={(productId) => handleProduct(productId)}
      />
    </>
  )
}

export {Create}
